import React from 'react';
import './HowItWorks.css';
import { NetworkIcon, FlashIcon, ShieldIcon } from './Icons';

const HowItWorks = () => {
  const steps = [
    {
      icon: <NetworkIcon size={40} color="#00d4ff" />,
      title: 'What if you order before or during or after the transfer?',
      description: 'Simply select your preferred cryptocurrency and enter the amount you wish to purchase. Our system supports multiple networks for your convenience.'
    },
    {
      icon: <FlashIcon size={40} color="#00d4ff" />,
      title: 'Do We issue a Flasher?',
      description: 'Yes! Once your order is confirmed, we process your Flash USDT immediately. Our automated system ensures quick and reliable delivery to your wallet.'
    },
    {
      icon: <ShieldIcon size={40} color="#00d4ff" />,
      title: 'Why should I trust your platform?',
      description: 'We prioritize security and transparency. All transactions are encrypted, and we maintain strict privacy standards. Our support team is available 24/7 to assist you.'
    }
  ];

  return (
    <section className="how-it-works" id="how-it-works">
      <div className="container">
        <h2>HOW Flashseller WORKS</h2>
        <p className="subtitle">
          We offer a fast and secure way to get Flash USDT. Follow these simple steps to complete your transaction.
        </p>

        <div className="steps-container">
          {steps.map((step, index) => (
            <div key={index} className="step-card">
              <div className="step-icon">{step.icon}</div>
              <div className="step-number">{index + 1}</div>
              <h3>{step.title}</h3>
              <p>{step.description}</p>
            </div>
          ))}
        </div>

        <div className="security-badge">
          <div className="shield-icon">
            <ShieldIcon size={48} color="#10b981" />
          </div>
          <div className="security-text">
            <h4>100% Secure Platform</h4>
            <p>Your transactions are protected with bank-grade encryption</p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HowItWorks;
